import MainPrefaceMobileSize from './MainPrefaceMobileSize'
import MainPrefaceTabletDesktopSize from './MainPrefaceTabletDesktopSize'

export default function MainPreface() {
  return (
    <>
      <MainPrefaceMobileSize />
      <MainPrefaceTabletDesktopSize />
    </>
  )
}
